import React from 'react';
import { Outlet } from 'react-router-dom';

type PhoneProviderContextProps = {
	state: {
		phoneNumberHref: string;
		phoneNumberDisplay: string;
	};
};

interface PhoneProviderProps {
	phone: string;
}

export const PhoneProviderContext = React.createContext<PhoneProviderContextProps | null>(null);

const formatPhoneForLink = (phone: string): string => {
	const digits = phone.replace(/\D/g, '');
	return `tel:${digits}`;
};

const PhoneProvider: React.FC<PhoneProviderProps> = ({ phone, children }) => {
	const phoneNumberHref = React.useMemo<string>(() => formatPhoneForLink(phone), [phone]);
	const phoneNumberDisplay = React.useMemo<string>(() => phone, [phone]);

	const value: PhoneProviderContextProps = {
		state: {
			phoneNumberHref,
			phoneNumberDisplay,
		},
	};

	return (
		<PhoneProviderContext.Provider value={value}>
			{children || <Outlet />}
		</PhoneProviderContext.Provider>
	);
};

export default PhoneProvider;
